import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  headerContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '48px',
    backgroundColor: '#053742',
    padding: '0 13px'
  },
  configContainer: {
    border: '3px solid #F1F0F5',
    borderRadius: '24px',
    margin: '16px 8px'
  },
  configHeaderContainer: {
    display: 'flex',
    alignItems: 'center',
    height: '47px',
    borderBottom: '3px solid #F1F0F5',
    padding: '0 18px'
  },
  configBodyContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 18px'
  },
  dialogActionButtons: {
    "& .MuiButton-root": {
      background: "#39A2DB",
      marginBottom: 10,
      "&:hover": {
        background: "#226183",
      },
    },
  },
  dialogPaper: {
    height: 260,
    width: 472,
    fontSize: 10,
    "& .MuiButton-root": {
      borderRadius: 24,
    },
    "& .MuiDialogActions-root": { justifyContent: "center" },
    "& .MuiTypography-root": { fontWeight: 800 },
  },
  confirmRestoreDefaultsDialog: {
    "& .MuiDialogActions-root": { justifyContent: "center" },
    "& .MuiDialogContent-root": { display: "flex", flexDirection: "column", textAlign: "center", justifyContent: "center", height: "100%" },
    "& .MuiButton-root": { borderRadius: 24 },
    "& .MuiDialogContentText-root": { marginTop: 12, marginBottom: 4, width: "100%" },
  },
  divDialog: {
    display: "flex",
  },
  divDialogButton: {
    display: "flex",
    justifyContent: "center",
  },
  errorText: {
    fontFamily: 'Work Sans !important',
    fontSize: '12px !important',
    lineHeight: '22px !important',
    color: '#ff0000 !important',
  },
  headerCellText: {
    fontFamily: 'Work Sans !important',
    fontSize: '14px !important',
    lineHeight: '22px !important',
    color: '#000000 !important',
    fontWeight: '400 !important',
    borderBottom: "none !important", 
    borderTop: '3px solid #F1F0F5',
    textAlign: 'center',
  },
  bodyCellText: {
    fontFamily: 'Work Sans !important',
    fontSize: '14px !important',
    lineHeight: '16px !important',
    color: '#000000 !important',
    fontWeight: '400 !important',
    borderBottom: "none !important", 
    borderTop: '3px solid #F1F0F5',
    textAlign: 'center',
    height: "43px",
  },
  toolbarClass: {
    // backgroundColor: '#F1F0F5 !important',
    border: 'none',
    paddingLeft: 0,
    borderRadius: '5px',
    width: '100%',
    marginLeft: '-3px',
  },
  wrapperClass: {
    // backgroundColor: '#F1F0F5 !important',
    // borderRadius: '10px',
    // padding: '10px',
  },
  editorClass: {
    fontFamily: 'Work Sans !important',
    color: "#000000 !important",
    border: '1px solid #F1F0F5',
    padding: '0px 12px !important',
    minHeight: '60vh',
    backgroundColor: '#F1F0F5 !important',
    borderRadius: '10px',
  },
  inputStyle: {
    borderRadius: "24px !important",
    height: "35px !important",
    boxShadow: "0px 0px 40px 0px rgba(0, 0, 0, 0.1) !important",
    outline: "none !important",
    width: "100%",
  },
}));
